import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-warehouse',
  templateUrl: './warehouse.component.html',
  styleUrls: ['./warehouse.component.css']
})
export class WarehouseComponent implements OnInit {


  constructor(private userService:ServiceService,private route: ActivatedRoute, private router: Router) { }

  output:any=[]
  alert=""
  ListId=""
  ListName=""
  admin:any=[]
  New_count=0;
  count=0;
  next_output:any=[];
  loaderShown=true;
  cardShown=false;
   update_Data={
    warehouse_id: null,
    is_not_shop: false
}





  //-----function for urouting to edit user details---------
  EditDetails(){

    console.log("Clicked")
    
    this.router.navigateByUrl(('admin/kpi-menu/add-working-edit'));  
    document.body.scrollTop = document.documentElement.scrollTop = 0;

  }

  onCheckboxChange(event: any, Id:any): void {
    const isChecked = event.checked;
    console.log('Checkbox is checked:', isChecked);
    console.log('event:', event);
    this.update_Data.warehouse_id=Id
    this.update_Data.is_not_shop=isChecked
    this.userService.updateWarehouses(this.update_Data).subscribe((res)=>{
      console.log("response=",res);         
        this.userService.showToast('success', res.message)
        this.ngOnInit();   
  })

  }
  
  //----paging previous----------
  clicks_previous(){
    if(this.New_count==0){
      return;
    }

    else{
      this.New_count=this.New_count-1;
      this.count=this.New_count; 
    }
    this.userService.viewWarehouses(this.count).subscribe((res)=>{
     
      if(res.data[0].username=='admin'){

        this.output=res.data.slice(1)

      }
      else{
        this.output=res.data
      }
    })

  }
  //------paging next--------------
  clicks_next(){

    this.count=this.count+1
    this.userService.viewWarehouses(this.count).subscribe((res)=>{
    this.next_output=res.data
    if(this.next_output.length!=0){
      this.output=this.next_output;
      this.New_count=this.count;
    }
  })



  }
  ngOnInit(): void {

    this.userService.viewWarehouses(this.count).subscribe((res)=>{
    this.output=res.data
   

    this.loaderShown=false;
    this.cardShown=true;
  
    console.log("output=",this.output)

    })
  }

}
